module.exports = __webpack_public_path__ + "static/santeboutiquecenter-ce19428f374dc7a89889abe402614ef8.jpg";